import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { message } from 'antd'
import ArticleVersionsService from '../../services/ArticleVersionService'

export const initialState = {
	loading: false,
	articleVersions: [],
	articleVersionData: null,
}

export const getArticleVersions = createAsyncThunk(
	'articleVersions/fetchByArticleId',
	async (articleId, { rejectWithValue }) => {
		try {
			const response = await ArticleVersionsService.getArticleVersions(articleId)
			return response.result
		} catch (err) {
			return rejectWithValue(err.response?.data?.message || 'Error')
		}
	}
)

export const articleVersionSlice = createSlice({
	name: 'articleVersions',
	initialState,
	reducers: {
		showLoading: (state) => {
			state.loading = true
		},
		disableLoading: (state) => {
			state.loading = false
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getArticleVersions.pending, (state) => {
				state.loading = true
				state.articleVersions = []
			})
			.addCase(getArticleVersions.fulfilled, (state, action) => {
				state.loading = false
				state.articleVersions = action.payload
			})
			.addCase(getArticleVersions.rejected, (state, action) => {
				state.loading = false
				message.error(action.payload, 5)
			})
	},
})

export const { showLoading, disableLoading } = articleVersionSlice.actions

export default articleVersionSlice.reducer
